import axios from "axios";
import { BASE_URL } from "../../helper/base-url";
import store from "../../redux/store";
import { login } from "../../redux/reducer/authReducer";

export const getUsers = async (page, limit) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const limitParam = limit != null ? `&limit=${encodeURIComponent(String(limit))}` : "";
  const users = await axios
    .get(`${BASE_URL}users?page=${page}${limitParam}`, {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return users;
};

export const browseFreelancerService = async (page, filters, limit) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const limitParam =
    limit != null && Number(limit) > 0
      ? `&limit=${encodeURIComponent(String(limit))}`
      : "";
  const projects = await axios
    .get(
      `${BASE_URL}browse-freelancers?page=${page}${limitParam}&filters=${encodeURIComponent(JSON.stringify(filters || {}))}`,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userData?.token}`,
        },
      },
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      // When the request doesn't reach the server (CORS, DNS, connection refused),
      // axios has no `error.response` and callers would crash reading `.data`.
      return (
        error?.response || {
          status: 0,
          data: null,
          error: error?.message || "Network error",
        }
      );
    });
  return projects;
};

export const adminVerifyUser = async (id) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const res = await axios
    .post(
      `${BASE_URL}admin-verify-user`,
      { id },
      {
        headers: {
          Authorization: `Bearer ${userData?.token}`,
        },
      },
    )
    .then((response) => response)
    .catch((error) => error.response);
  return res;
};

export const adminUpdateUserRole = async (id, user_type) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const res = await axios
    .post(
      `${BASE_URL}admin-update-user-role`,
      { id, user_type },
      {
        headers: {
          Authorization: `Bearer ${userData?.token}`,
        },
      },
    )
    .then((response) => response)
    .catch((error) => error.response);
  return res;
};

export const adminUpdateUser = async (id, payload) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const res = await axios
    .patch(`${BASE_URL}admin-users/${id}`, payload, {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response)
    .catch((error) => error.response);
  return res;
};

export const adminCreateUser = async (payload) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const res = await axios
    .post(`${BASE_URL}admin-create-user`, payload, {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response)
    .catch((error) => error.response);
  return res;
};

export const adminImportUsers = async (users) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const res = await axios
    .post(`${BASE_URL}admin-import-users`, { users }, {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response)
    .catch((error) => error.response);
  return res;
};

export const adminBulkUsers = async (action, userIds) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const res = await axios
    .post(`${BASE_URL}admin-bulk-users`, { action, user_ids: userIds }, {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response)
    .catch((error) => error.response);
  return res;
};

export const adminDeleteUser = async (id) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const res = await axios
    .delete(`${BASE_URL}admin-users/${id}`, {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
      },
    })
    .then((response) => response)
    .catch((error) => error.response);
  return res;
};

export const enableDisableUser = async (status, id) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const users = await axios
    .post(
      `${BASE_URL}enable-disable-user`,
      { is_active: status, id: id },
      {
        headers: {
          Authorization: `Bearer ${userData?.token}`,
        },
      },
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return users;
};

export const signup = async (data) => {
  const user = await axios
    .post(`${BASE_URL}signup`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return user;
};

export const getUserById = async (id) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const users = await axios
    .get(`${BASE_URL}users/${id}`, {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return users;
};

export const getPublicFreelancerProfile = async (slug) => {
  const profile = await axios
    .get(`${BASE_URL}public/freelancers/${encodeURIComponent(slug)}`)
    .then((response) => response)
    .catch((error) => {
      return (
        error?.response || {
          status: 0,
          data: null,
          error: error?.message || "Network error",
        }
      );
    });
  return profile;
};

/**
 * Re-fetch the current user from the API and persist to localStorage + Redux
 * (subscription_id, active_subscription, step, etc.) so UI matches the server
 * after subscribe, checkout, or cancel.
 */
export async function refreshStoredUserSession() {
  let parsed;
  try {
    parsed = JSON.parse(localStorage.getItem("userData") || "null");
  } catch {
    return false;
  }
  if (!parsed?.token || parsed?.user?.id == null) {
    return false;
  }

  const res = await getUserById(parsed.user.id);
  if (res?.status !== 200) {
    return false;
  }

  const updatedUser = res?.data?.result?.data;
  if (!updatedUser) {
    return false;
  }

  const next = { ...parsed, user: updatedUser };
  localStorage.setItem("userData", JSON.stringify(next));
  store.dispatch(login(next));
  return true;
}

export const verifyUser = async (id, token) => {
  const users = await axios
    .get(`${BASE_URL}api/verify?id=${encodeURIComponent(id)}&token=${encodeURIComponent(token)}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return users;
};

export const changePassword = async (payload) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const res = await axios
    .post(`${BASE_URL}change-password`, payload, {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
      },
    })
    .then((response) => response)
    .catch((error) => {
      return (
        error?.response || {
          status: 0,
          data: { message: error?.message || "Network error" },
        }
      );
    });
  return res;
};

export const updateProfile = async (formData) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const profile = await axios
    .post(`${BASE_URL}update-profile`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userData?.token}`,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return (
        error?.response || {
          status: 0,
          data: { message: error?.message || "Network error" },
        }
      );
    });
  return profile;
};

export const updatePortfolioImages = async (formData) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const res = await axios
    .post(`${BASE_URL}update-portfolio-images`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userData?.token}`,
      },
    })
    .then((response) => response)
    .catch((error) => {
      return (
        error?.response || {
          status: 0,
          data: { message: error?.message || "Network error" },
        }
      );
    });
  return res;
};

export const inquiry = async (formData) => {
  const inquire = await axios
    .post(`${BASE_URL}inquire`, formData)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return inquire;
};
